import styled from 'styled-components';
import { Button } from 'components/atoms/button';

export const Lines = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
`;

export const Trigger = styled(Button).attrs({
  size: 'small',
  type: 'text',
})`
  min-width: 160px;
  justify-content: space-between;

  svg {
    margin-right: -12px;
    margin-left: 8px;
    color: var(--gray-40);
  }
  &:active {
    background-color: transparent;
  }
`;
